import { ENDPOINT_LOG_INDEX, ENDPOINT_LOG_INDEX_ORDERBY, ENDPOINT_LOG_INDEX_SET_PAGE, ENDPOINT_LOG_INDEX_FILTER } from 'client/redux/endpoint/log/constants';
import { reduceTableActions } from 'client/redux/table/reducerHelpers';
import { reduceByTypes } from 'client/redux/apiHelpers';

const defaultState = {
  error: null,
  isReading: false,
  logs: null,
  filter: {endpointId: '', type: '', level: '', timeStart: '', timeEnd: ''},
  page: 1,
  orderBy: 'updatedAt',
  orderDirection: 'DESC',
};

export default function indexReducer (state = defaultState, action) {
  state = reduceByTypes(ENDPOINT_LOG_INDEX, state, action, {requestProp: 'isReading', successSpread: true});
  state = reduceTableActions([ENDPOINT_LOG_INDEX_FILTER, ENDPOINT_LOG_INDEX_SET_PAGE, ENDPOINT_LOG_INDEX_ORDERBY], state, action);
  return state;
}
